import React from 'react';
import FlowModelSummary from '../FlowModelSummary/FlowModelSummary';
import IPublishedFlowModel from '@Shared.Angular/@types/core/contracts/queryModel/flowModels/publishedFlowModel';
import { Guid } from '@Shared.Angular/@types/guid';

type Props = {
  flowModels: IPublishedFlowModel[];
  onFlowModelClicked?: (flowModelId: string) => void;
};

const FlowModelSummaryList = ({ flowModels, onFlowModelClicked }: Props) => {
  const handleFlowModelClick = (id: Guid) => {
    onFlowModelClicked?.(id);
  };

  return (
    <ul>
      {flowModels.map((flowModel) => (
        <li key={flowModel.id}>
          <FlowModelSummary
            flowModelSummary={flowModel}
            onFlowModelClick={handleFlowModelClick}
            showConfidentialType={true}
          />
        </li>
      ))}
    </ul>
  );
};

export default FlowModelSummaryList;
